import { createSelector } from 'reselect';

const slice = state => state.search.searchResultsMap;

export const searchResultsMapItemsSelector = createSelector(
  slice,
  ({ items }) => items
);

export const searchResultsMapIsFetchingSelector = createSelector(
  slice,
  ({ isFetching }) => isFetching
);



// WEBPACK FOOTER //
// ./src/selectors/searchResultsMap.js